import Isotope from 'isotope-layout';
import $win from '../utils/globals.js';

const masonryLayout = () => {
	const $container = $('.section-gallery');

	if ( ! $container.length ) {
		return;
	}

	const $gridContainer = $container.find('.section__grid');

	let grid = new Isotope( $gridContainer[0], {
		itemSelector: '.section__item',
		layoutMode: 'masonry',
	});

	$('.js-filters-masonry ul a').on('click', function(e){
		e.preventDefault();

		let filterValue = $(this).data('filter');

		grid.arrange({ filter: filterValue });

		$(this).closest('li').addClass('is-active').siblings().removeClass('is-active');
	})

	setTimeout(function(){
		grid.layout();
	}, 10);

}

masonryLayout();
